import Layout from "../components/layout/Layout";
import Slider from "../components/home/Slider";
import AboutSection from "../components/sections/AboutSection";
import QuickLinks from "../components/sections/QuickLinks";
import WhyChooseUs from "../components/sections/WhyChooseUs";
import AcademicPrograms from "../components/sections/AcademicPrograms";
import TransportService from "../components/sections/TransportService";
import FacultyCarousel from "../components/sections/FacultyCarousel";
import CampusFacilities from "../components/sections/CampusFacilities";
import Testimonials from "../components/sections/Testimonials";

export default function Home() {
  return (
    <Layout>
      <Slider />
      <QuickLinks />
      <AboutSection />
      <WhyChooseUs />
      <AcademicPrograms />
      <TransportService />
      <FacultyCarousel />
      <CampusFacilities />
      <Testimonials />
    </Layout>
  );
}
